import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

import StackCard from '../component/StackCard'
import Header from '../component/Header'
import Footer from '../component/Footer'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Achivment from "../component/Achivment";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const tabsData = [
    {
        id: 1,
        title: "Overview",
        content:
            "This is overview content. Add company details, fintech services or any introduction here.",
    },
    {
        id: 2,
        title: "Services",
        content:
            "This section contains your services like loan APIs, AI agents, payment gateway, fintech solutions.",
    },
    {
        id: 3,
        title: "Industries",
        content:
            "Industries we serve including fintech, banking, insurance, healthcare and enterprise.",
    },
    {
        id: 4,
        title: "Contact",
        content:
            "You can show contact details, email, phone number and support information.",
    },
];

export default function HybridFinance() {
    const ccd = [
        "Business Expansion",
        "Raise Capital",
        "Investor Confidence",
        "Delayed Equity Dilution",
        "Startup Funding",
        "Flexible Structuring",
    ];
    const ocd = [
        "Non-Convertible Debentures",
        "Listed Bonds",
        "Commercial Papers",
        "Perpetual Bonds",
        "Masala Bonds",
        "Trade Finance",
    ];

    const mezzanine = [
       
        { title: "Reduced Ownership Dilution" },
        { title: "Flexible Repayment Structure" },
        { title: "Supports Large Transactions" },
         { title: "Growth Capital Access" },
        { title: "Investor Confidence" },
        { title: "Faster Funding" },


    ];
    const values = [
        {
            title: "Flexible Conversion",
            desc: "Choose between repayment or equity conversion.",
        },
        {
            title: "Growth Funding",
            desc: "Supports business expansion and working capital.",
        },
        {
            title: "Investor-Friendly",
            desc: "Provides lower risk with flexible returns.",
        },
        {
            title: "Smart Capital Planning",
            desc: "Delays equity dilution and improves cash flow.",
        },

    ];

    const preferential = [
        {
            title: "Preferential Returns",
            desc: "Receive dividend priority over common shareholders.",
        },
        {
            title: "Structured Ownership",
            desc: "Balanced funding with controlled ownership dilution.",
        },
        {
            title: "Stable Investment",
            desc: "Predictable returns with lower equity risk.",
        },
        {
            title: "Capital Strength",
            desc: "Enhances long-term financing and business growth.",
        },

    ];





    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">

                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Expertise
                        </span>
                    </div>
                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Expertise:{" "}
                            <span className="text-dark-gold">
                                Hybrid Finance
                            </span>

                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-lg sm:text-base lg:text-2xl leading-relaxed mb-8">
                            Customized financing solutions combining debt and equity instruments such as CCDs, OCDs, mezzanine finance, and preference shares.
                            Structured to balance risk, improve leverage efficiency, and support expansion with flexible capital.
                        </p>





                    </div>
                </div>

                {/* section one */}
                <section className="py-20 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5">
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium">
                                    CCD
                                </span>

                                <p className="text-2xl md:text-3xl text-white leading-tight mb-6">
                                    Compulsorily Convertible Debentures converting into equity after a predefined tenure.
                                </p>
                                <h4 className="text-dark-gold text-xl pt-4">Compulsorily Convertible Debentures Benefits</h4>
                                <div className="grid grid-cols-3 gap-4 ">
                                    {ccd.map((point, index) => (
                                        <div
                                            key={index}
                                            className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                        >


                                            <div>
                                                <h4 className="text-sm  text-white pt-3">
                                                    {point}
                                                </h4>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* section two */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium mb-5">
                                    OCD
                                </span>
                                <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                    Optionally Convertible Debentures offering flexibility between repayment and equity conversion.
                                </p>
                                <div className="space-y-6">
                                    {values.map((item, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, x: -40 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            transition={{ delay: i * 0.2, duration: 0.5 }}
                                            viewport={{ once: true }}
                                            className="group py-2 px-4 hover:shadow-xl transition-all border rounded-lg"
                                        >
                                            <div className="flex justify-between items-start gap-4 ">
                                                <div className="">
                                                    <h3 className="text-lg font-semibold text-white">
                                                        {item.title}
                                                    </h3>
                                                    <p className="text-sm text-white/70 mt-1">
                                                        {item.desc}
                                                    </p>
                                                </div>

                                                {/* Arrow */}
                                                <span className="text-xl text-slate-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition">
                                                    {/* <ArrowOutwardIcon/> */}
                                                </span>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>

                            {/* Right Points */}
                            <div className="space-y-5"></div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* three start */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div className="">


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5 " >
                                <div className="space-y-5 border-1">
                                    <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium ">
                                        Mezzanine
                                    </span>

                                    <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                        Subordinated financing structure bridging the gap between senior debt and equity.
                                    </p>
                                    <div className=" ">
                                        {mezzanine.map((item, i) => (
                                            <motion.div
                                                key={i}
                                                initial={{ opacity: 0, x: -40 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ delay: i * 0.2, duration: 0.5 }}
                                                viewport={{ once: true }}
                                                className="group py-2 px-4 hover:shadow-xl transition-all "
                                            >
                                                <div className="flex" >
                                                    <h3 className="text-lg text-white border p-4 rounded-lg">
                                                        {item.title}
                                                    </h3>

                                                    {/* Arrow */}
                                                    <span className="text-xl text-slate-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition">
                                                        {/* <ArrowOutwardIcon/> */}
                                                    </span>
                                                </div>
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* four start */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div className="">

                                <div className="space-y-5 border-1">
                                    <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium">
                                        Preference Shares
                                    </span>

                                    <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                        Hybrid equity instruments providing preferential returns and structured ownership benefits.
                                    </p>

                                    <div className="space-y-6">
                                        {preferential.map((item, i) => (
                                            <motion.div
                                                key={i}
                                                initial={{ opacity: 0, x: -40 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ delay: i * 0.2, duration: 0.5 }}
                                                viewport={{ once: true }}
                                                className="group py-2 px-4 hover:shadow-xl transition-all"
                                            >
                                                <div className="flex justify-between items-start gap-4">
                                                    <div>
                                                        <h3 className="text-lg font-semibold text-dark-gold">
                                                            {item.title}
                                                        </h3>
                                                        <p className="text-sm text-slate-300 mt-1">
                                                            {item.desc}
                                                        </p>
                                                    </div>

                                                    {/* Arrow */}
                                                    <span className="text-xl text-slate-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition">
                                                        {/* <ArrowOutwardIcon/> */}
                                                    </span>
                                                </div>
                                            </motion.div>
                                        ))}
                                    </div>

                                </div>
                            </div>

                            {/* Right Points */}
                            <div className="space-y-5 " >

                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

            </section>




            <Achivment />
            <Footer />
        </div>
    )
}



